<script>
    import UploadImage from '@/components/base-components/UploadImage.vue';
    import { updateProviderImage } from '@/api/providers.js';

    export default {
        components: {
            UploadImage: UploadImage,
        },
        computed: {
            editData() {return this.$store.getters.PAG_PROVIDER_EDIT},
            provider() {return this.$store.getters.PROVIDER_BY_ID(this.editData.id)},
        },
        methods: {
            async updateImage(event) {
                const file = event.target.files[0];
                const respone = await updateProviderImage(file, this.editData.id);
                if (respone != null) {
                    this.provider.icon_path = respone.url;
                }
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <div class="upload_image_container mb_10">
            <img
                :src="provider['icon_path']"
            >
        </div>
        <UploadImage 
            :uploadMethod="updateImage"
        />
    </div>
</template>